'use client'

import { NavBar }              from './sections/NavBar'
import { HeroSection }         from './sections/HeroSection'
import { MarqueeSection }      from './sections/MarqueeSection'
import { PainSection }         from './sections/PainSection'
import { FeaturesSection }     from './sections/FeaturesSection'
import { TestimonialsSection } from './sections/TestimonialsSection'
import { PricingSection }      from './sections/PricingSection'
import { FAQSection }          from './sections/FAQSection'
import { FinalCTASection }     from './sections/FinalCTASection'
import { FooterSection }       from './sections/FooterSection'
import { FixedBottomBar }      from './sections/FixedBottomBar'

export function LandingPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#F6F3EC', overflowX: 'hidden' }}>
      <NavBar />

      <main id="main-content">
        <HeroSection />
        <MarqueeSection />
        <PainSection />
        <FeaturesSection />
        <TestimonialsSection />
        <PricingSection />
        <FAQSection />
        <FinalCTASection />
      </main>

      <FooterSection />
      <FixedBottomBar />
    </div>
  )
}
